export const matchReducer=(matches=[],action)=>{
    if(action.type==="FETCH_MATCHES"){
        return action.payload;
    }
    return matches;
}
export const singleMatchReducer=(match=null,action)=>{
    if(action.type==="GET_MATCH"){
        return action.payload;
    }
    return match;
}